export const setToken = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};
export const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};
export const setAccessToken = (accessToken) => {
  return localStorage.setItem("accessToken", accessToken);
};
export const getRefreshTokenAndEmail = () => {
  const res = {
    refreshToken: localStorage.getItem("refreshToken"),
    email: localStorage.getItem("email"),
  };
  return res;
};
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};
export const removeAccessToken = () => {
  localStorage.removeItem("accessToken");
};
export const removeRefreshToken = () => {
  localStorage.removeItem("refreshToken");
};
export const clearLocalStorage = () => {
  localStorage.clear();
};
